import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { agreementKeys } from './agreementKeys';

/** For a refused call made outside React Query, which useAccessRefusalWatcher cannot see. */
export function useAccessRecheck(agreementId: string | undefined): () => void {
    const queryClient = useQueryClient();
    return useCallback(() => {
        if (!agreementId) return;
        void queryClient.invalidateQueries({ queryKey: agreementKeys.access(agreementId) });
    }, [queryClient, agreementId]);
}
